import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import {serviceMotionList} from '../../utils/serviceMotionList';

import FeatureCardBox from '../common/FeatureCardBox';

import {ReactComponent as AccessLevelImg} from '../../assets/admin04/access-level.svg';
import {ReactComponent as ScenarioExampleImg} from '../../assets/admin04/scenario-example.svg';
import {ReactComponent as ScenarioImg} from '../../assets/admin04/scenario.svg';

export default function Admin04() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');

    const dataMap = [
        { 
            type: 'scenario-example',
            title: '시나리오를 직접 제작하세요',
            subTitle: '질문과 답변을 직접 설계하여 완벽한 응답을 만드세요',
            Image: ScenarioExampleImg
        },
        { 
            type: 'access-level',
            title: '보안 단계를 설정하세요',
            subTitle: '중요도에 따라 정보 접근 범위를 설정하세요',
            Image: AccessLevelImg
        }
    ];

    return (
        <div>
            <FeatureCardBox
                type='scenario'
                IconImage={ScenarioImg}
                keyword='시나리오 페이지'
                title={mobileSmall ? <>맞춤형 시나리오로<br />똑똑하고 안전하게</>: '맞춤형 시나리오로 똑똑하고 안전하게'}
                featureCardList={dataMap}
                titleMotion={serviceMotionList.titleMotion}
                cardMotion={serviceMotionList.cardMotion}
                motionVariant={serviceMotionList.admin04}
            />
        </div>
    );
}
